module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      'el-cascader-panel',
      _vm.border && 'is-bordered'
    ],
    on: {
      "keydown": _vm.handleKeyDown
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('cascader-menu', {
      key: index,
      ref: "menu",
      refInFor: true,
      attrs: {
        "index": index,
        "nodes": menu
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f9f752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/cascader-panel/src/cascader-panel.vue
// module id = 2070
// module chunks = 137